import { Card } from '@care/react-component-lib';
import { Box, Typography, useTheme } from '@mui/material';
import { useState } from 'react';

import useResponsive from '@/components/hooks/useResponsive';
import { CardType } from '@/constants';
import { Caregiver, Service } from '@/types';
import CaregiverCardBack from './CaregiverCardBack';
import CaregiverCardFront from './CaregiverCardFront';

const CaregiverReviewCard = ({ card }: { card: Caregiver | Service }) => {
  const theme = useTheme();
  const { isDesktop } = useResponsive();
  const [isBackOfCard, setIsBackofCard] = useState(false);
  const [isFading, setIsFading] = useState(false);

  const flipCard = (isBack: boolean) => {
    setIsFading(true);
    setTimeout(() => {
      setIsFading(false);
      setIsBackofCard(isBack);
    }, 500);
  };

  const isCaregiverType = (c: Caregiver | Service): c is Caregiver => {
    return c.type === CardType.Caregiver;
  };
  const isCaregiver = isCaregiverType(card);

  return (
    <Card
      onMouseEnter={() => {
        if (isCaregiver && isDesktop) flipCard(true);
      }}
      onMouseLeave={() => {
        if (isCaregiver && isDesktop) flipCard(false);
      }}
      sx={{
        width: '302px',
        height: '403px',
        borderRadius: '32px',
        border: 'none',
        position: 'relative',
      }}>
      {isCaregiver ? (
        <>
          <CaregiverCardBack card={card} isVisible={isBackOfCard} isFading={isFading} />
          <CaregiverCardFront card={card} isVisible={!isBackOfCard} isFading={isFading} />
        </>
      ) : (
        <Box
          data-testid="caregiver-card-info"
          sx={{
            padding: theme.spacing(3, 0, 4, 2),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            backgroundColor: theme.palette.background.accent?.accent2,
            color: theme.palette.text.primary,
          }}>
          <Box sx={{ width: '244px' }}>
            <Typography variant="serifHeadline2">{card.headline}</Typography>
          </Box>

          <Box>
            {card.services.map((service) => (
              <Box
                key={service.name}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  marginBottom: theme.spacing(1),
                }}>
                {service.icon}
                <Box sx={{ ml: '5px' }}>
                  <Typography variant="h5">{service.name}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default CaregiverReviewCard;
